import { render, staticRenderFns } from "./PatientStates.vue?vue&type=template&id=070d4a69&scoped=true&"
import script from "./PatientStates.vue?vue&type=script&lang=js&"
export * from "./PatientStates.vue?vue&type=script&lang=js&"
import style0 from "./PatientStates.vue?vue&type=style&index=0&id=070d4a69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d4a69",
  null
  
)

export default component.exports